import { cn } from "@moe/oss/utils/utils";
import { History } from "@web/route-services/chat/History";
import { DataContextProvider } from "@web/route-services/chat/data-context";
import { ServiceContextProvider } from "@web/route-services/chat/service-context";
import { useRef } from "react";
import { Input } from "./Input";

interface Props {
  chatID: number;
  className?: string;
  [x: string]: any;
}

export function Chatbox({ chatID, className, ...rest }: Props) {
  const historyRef = useRef<Element | null>(null);

  return (
    <DataContextProvider chatID={chatID}>
      <ServiceContextProvider chatID={chatID} historyRef={historyRef}>
        <div className={cn("relative flex h-full w-full grow flex-col", className)} {...rest}>
          <History globalHistoryRef={historyRef} />
          <Input className="" />
        </div>
      </ServiceContextProvider>
    </DataContextProvider>
  );
}
